import React, { useEffect, useState } from 'react';
import { Menu, X, Phone, Globe } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Header() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleLang = () => {
    setLang(lang === 'en' ? 'es' : 'en');
  };
  const navLinks = [{
    name: t('nav.services'),
    href: '#services'
  }, {
    name: t('nav.about'),
    href: '#about'
  },
  // { name: t('nav.insurance'), href: '#insurance' },
  {
    name: t('nav.contact'),
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="flex justify-between items-center" data-id="element-81">
          {/* Logo */}
          <div className="flex items-center" data-id="element-82">
            <a href="#" className="flex items-center gap-3" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/4sxQ2e4dUAxRWLCzqVdgyT/bohevia.jpg" alt="Reading Behavioral Health Center" className="h-12 w-auto object-contain" data-id="element-84" />
              <div className="hidden md:block" data-id="element-85">
                <h1 className="text-xl font-bold text-brand-deep leading-tight" data-id="element-86">
                  Reading Behavioral
                </h1>
                <p className="text-sm text-brand-teal font-medium" data-id="element-87">
                  Health Center
                </p>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-88">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-600 hover:text-brand-teal font-medium transition-colors" data-id="element-89">
                {link.name}
              </a>)}

            <button onClick={toggleLang} className="flex items-center gap-1 text-gray-600 hover:text-brand-deep font-medium px-3 py-1 rounded-full border border-gray-200 hover:border-brand-teal transition-all" data-id="element-90">
              <Globe className="w-4 h-4" data-id="element-91" />
              <span data-id="element-92">{lang === 'en' ? 'ES' : 'EN'}</span>
            </button>

            <a href="tel:6103747035" className="bg-brand-teal hover:bg-brand-deep text-white px-5 py-2.5 rounded-full font-semibold transition-all shadow-md hover:shadow-lg flex items-center gap-2" data-id="element-93">
              <Phone className="w-4 h-4" data-id="element-94" />
              {t('nav.call')}
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-4" data-id="element-95">
            <button onClick={toggleLang} className="text-gray-600 font-medium" data-id="element-96">
              {lang === 'en' ? 'ES' : 'EN'}
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-brand-deep p-2" data-id="element-97">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-98" /> : <Menu className="w-6 h-6" data-id="element-99" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-100">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-lg font-medium text-gray-800 py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
              {link.name}
            </a>)}
          <a href="tel:6103747035" className="bg-brand-teal text-white text-center py-3 rounded-xl font-semibold mt-2" data-id="element-102">
            {t('nav.call')}
          </a>
        </div>}
    </header>;
}